import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { jetStreamInstance } from '../../../../shared/components';
const BankHeader = ({ }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{width: '105px' }}>Action(s)</TableCell>
                <TableCell>{jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</TableCell>
                <TableCell>Bank Name</TableCell>
                <TableCell>Account Holder Name</TableCell>
                <TableCell>Account Number</TableCell>
                <TableCell>SWIFT Code</TableCell>
                <TableCell style={{ minWidth: '125px' }}>Status</TableCell>
            </TableRow>
        </TableHead>
    )
}
export default BankHeader;